import React from 'react';
import Popup from './Popup';

type SelfieVerificationInfoPopupProps = {
    onClose: () => void;
};

export const SelfieVerificationInfoPopup: React.FC<SelfieVerificationInfoPopupProps> = ({ onClose }) => (
    <Popup onClose={onClose}>
        <div className="security-info-popup">
            <h3 className="H3_21">Как работает проверка селфи с паспортом?</h3>

            <div className="security-section">
                <h4 className="Subheader_17">Что это даёт</h4>
                <p>
                    После подписания договора клиентом мы дополнительно сверяем фото в паспорте и отдельное селфи с этим
                    паспортом. Так проще убедиться, что подписывает тот же человек, чей документ указан в договоре.
                </p>
                <p>
                    Также автоматически сверяются введённые в документе ФИО и серия с номером паспорта с тем, что
                    распознано на предоставленном фото паспорта — при расхождении вы увидите соответствующий статус и
                    сможете принять решение самостоятельно.
                </p>
            </div>

            <div className="security-section">
                <h4 className="Subheader_17">Что увидит инициатор</h4>
                <p>
                    Результат автоматической проверки отображается в статусе документа. Если сервис временно недоступен
                    или нужно ваше решение, вы всегда можете открыть документ, посмотреть снимки и завершить проверку
                    или отклонить договор вручную.
                </p>
            </div>
        </div>
    </Popup>
);
